export default "__VITE_ASSET__D3GS9zw5__"